import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Container, Row, Form, Button, Col, Accordion, Card } from "react-bootstrap";

const FormEspiritualidad = ({ defaultValues, submissionHandler }) => {
  const [validated] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>
      <Container fluid>
        <Row>
          <Col>
            <Accordion defaultActiveKey="0" className="mb-2">
              <Card>
                <Accordion.Toggle as={Card.Header} eventKey="0">
                  Estructura de la obra
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <Form.Row>
                      <Form.Group as={Col} xs={12} md controlId={`averageNumber`}>
                        <Form.Label>{"Número medio de personas en la obra"}</Form.Label>
                        <Form.Control
                          name={`averageNumber`}
                          type="number"
                          isInvalid={errors.averageNumber}
                          {...register(`averageNumber`, {
                            min: { value: 0, message: "El campo debe ser mayor o igual que 0" },
                          })}
                        />
                        <ErrorMessage errors={errors} name={`averageNumber`} render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                      </Form.Group>

                      <Form.Group as={Col} xs={12} md controlId={`totalNumber`}>
                        <Form.Label>{"Número de personas atendidas anualmente"}</Form.Label>
                        <Form.Control
                          name={`totalNumber`}
                          type="number"
                          isInvalid={errors.totalNumber}
                          {...register(`totalNumber`, {
                            min: { value: 0, message: "El campo debe ser mayor o igual que 0" },
                          })}
                        />
                        <ErrorMessage errors={errors} name={`totalNumber`} render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Col>
        </Row>
      </Container>
      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormEspiritualidad;
